"use client"

import {
  Grid3X3,
  Heart,
  Home,
  LockKeyholeOpen,
  MessageCircle,
  Plus,
  Search,
  User,
  Users,
} from "lucide-react"
import Link from "next/link"
import { useState } from "react"
import { CreatePostModal } from "#/components/create/create-post-modal"
import { NotificationsPanel } from "#/components/social/notifications-panel"
import { UserSearch } from "#/components/social/user-search"
import { Avatar, AvatarFallback } from "#/components/ui/avatar"
import { Badge } from "#/components/ui/badge"
import { Button } from "#/components/ui/button"
import { useRouter } from "next/navigation"
import { authClient } from "#/lib/auth/client"
import { useUsername } from "#/hooks/use-username"

export function AppHeader() {
  const [showCreateModal, setShowCreateModal] = useState(false)
  const [showSearch, setShowSearch] = useState(false)
  const [showNotifications, setShowNotifications] = useState(false)
  const { data: username } = useUsername()

  // Mock notification count
  const unreadNotifications = 3

  const router = useRouter()
  const signout = authClient.useSignout()

  return (
    <>
      <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container flex h-16 items-center justify-between px-4">
          <div className="flex items-center gap-4">
            <Link href="/">
              <h1 className="text-2xl font-bold bg-gradient-to-r from-primary to-primary/60 bg-clip-text text-transparent cursor-pointer">
                SocialSignal
              </h1>
            </Link>
          </div>

          <div className="flex items-center gap-4">
            <Link href="/">
              <Button variant="ghost" size="sm">
                <Home className="h-5 w-5" />
              </Button>
            </Link>
            <Link href="/encryption-demo">
              <Button variant="ghost" size="sm" title="Encryption Demo">
                <LockKeyholeOpen className="h-5 w-5" />
              </Button>
            </Link>
            <Link href="/examples">
              <Button variant="ghost" size="sm" title="Profile Examples">
                <Grid3X3 className="h-5 w-5" />
              </Button>
            </Link>
            <Link href="/friends">
              <Button variant="ghost" size="sm" title="Friends & Following">
                <Users className="h-5 w-5" />
              </Button>
            </Link>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setShowSearch(true)}
            >
              <Search className="h-5 w-5" />
            </Button>
            <div className="relative">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => setShowNotifications(true)}
              >
                <Heart className="h-5 w-5" />
                {unreadNotifications > 0 && (
                  <Badge
                    variant="destructive"
                    className="absolute -top-1 -right-1 h-5 w-5 p-0 text-xs flex items-center justify-center"
                  >
                    {unreadNotifications}
                  </Badge>
                )}
              </Button>
            </div>
            <Button variant="ghost" size="sm">
              <MessageCircle className="h-5 w-5" />
            </Button>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setShowCreateModal(true)}
            >
              <Plus className="h-5 w-5" />
            </Button>
            <div className="flex items-center gap-2">
              <Link href={`/@${username}`}>
                <Avatar className="h-8 w-8 cursor-pointer">
                  {/* TODO: */}
                  {/* <AvatarImage
                    src={session?.user.image || "/placeholder.svg"}
                    alt={session?.user?.displayUsername ?? ""}
                  /> */}
                  <AvatarFallback>
                    <User className="h-4 w-4" />
                  </AvatarFallback>
                </Avatar>
              </Link>
              <Button
                variant="ghost"
                size="sm"
                onClick={async () => {
                  try {
                    await signout()
                  } catch (error) {
                    console.log(error)
                  }
                  router.push("/")
                }}
              >
                Signout
              </Button>
            </div>
          </div>
        </div>
      </header>

      <CreatePostModal
        open={showCreateModal}
        onOpenChange={setShowCreateModal}
      />
      <UserSearch isOpen={showSearch} onClose={() => setShowSearch(false)} />
      <NotificationsPanel
        isOpen={showNotifications}
        onClose={() => setShowNotifications(false)}
      />
    </>
  )
}
